module.exports = __webpack_public_path__ + "static/media/HCMM286.81ee40fb.jpg";